import { lazy } from 'react';

export const SettingsOrdersSavingsAsync = lazy(
    () => import('./SettingsOrdersSavings'),
);
